import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets-jai6qajn.emergentagent.net/job_web-app-hub-36/artifacts/ounaja4d_New%20BiasBuster%20Hat%20Logo%20%28With%20Web%20URL%29%20NO%20Background.PNG";

export default function Logo({ size = "h-14", showText = true, testId, inverse = false }) {
  return (
    <Link to="/" className="flex items-center gap-2 group" data-testid={testId}>
      <img src={LOGO_URL} alt="BBAP - Bias Buster" className={`${size} w-auto`} />
      {showText && (
        <span className="font-display font-bold tracking-tight leading-none">
          <span className={`text-xl md:text-2xl ${inverse ? "text-white" : "text-zinc-950"}`}>BIAS</span>
          <span className="text-xl md:text-2xl text-[#1E3A6E]"> BUSTER</span>
        </span>
      )}
    </Link>
  );
}
